//#region [IMPORT]

// === THIRD-PARTY ==
import { useNavigate } from "react-router-dom";

// === API ===
import { sendMessageData } from "api/prokey/prokey.websocket";

//#endregion

//-----------------------------------------------------------------
export const useLogout = () => {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const navigate = useNavigate();

  //#endregion

  //#region [METHOD]

  async function logout() {
    try {
      sendMessageData( 'LOGOUT' );
      navigate(`/login`, { replace: true } );
    } catch (error) {
      console.warn( error );
    }
  }

  //#endregion

  return logout;
};
